import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationError } from '@angular/router';
import { ErrorNotificationService } from './shared/services/error-notification.service';
import { AuthService } from './shared/services/auth.service';
import { CommonBookingService } from './bookings/shared/common-booking.service';
import { CommonService } from './shared/services/common.service';
import { NotificationIntervalService } from './shared/services/notification.interval.service';
import { filter, switchMap } from 'rxjs/operators';
import { timer, Subscription } from 'rxjs';
import { UtilService } from './shared/services/util.service';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { LoginService } from './auth/login/login.service';
import { PermissionsGuardService } from './shared/services/permissions-guard.service';
import { SessionManagementService } from './shared/services/session-management-service';
import rg4js from 'raygun4js';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'spot-mis';

  public route: string;
  public showSidebar = false;
  public showHeader = false;
  public showNotification = false;
  public notification: string;
  private notificationInfo: any;
  audioCreateBooking: HTMLAudioElement;
  audioVendorAcceptance: HTMLAudioElement;
  audiocabAllocation: HTMLAudioElement;
  timerSubs: any;
  timerObs: any;
  idleSubscription: Subscription;
  sessionExpirationMsg: string;
  idleTime: any;
  imgURL: string;
  headerTitle: string;
  openPolicyPopup = false;
  showCompanyPolicy = false;
  policyData: any;
  miscConfig: any;
  constructor(
    private router: Router,
    private errorNotificationService: ErrorNotificationService,
    private sessionNotificationService: SessionManagementService,
    private authService: AuthService,
    private commonService: CommonService,
    private commonBookingService: CommonBookingService,
    private notificationService: NotificationIntervalService,
    private notify: NotificationService,
    private utilService: UtilService,
    private idle: Idle,
    private loginService: LoginService,
    private permissionsGuardService: PermissionsGuardService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    this.imgURL = '../assets';
    this.registerIcon(this.imgURL);
    // this.setSectionVisibility(this.router.url);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setSectionVisibility(event.urlAfterRedirects);
      }
    });
  }

  reset() {
    this.idle.watch();
  }

  checkForIdleness() {
    this.commonService.fetchMiscConfig().subscribe((response: any) => {
      this.miscConfig = response;
      if (response && response['idleTimeInMinutes']) {
        this.idleTime = response['idleTimeInMinutes'];
      }
      this.idle.setIdle(this.idleTime * 60);
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      this.idleSubscription = this.idle.onIdleStart.subscribe(() => {
        this.loginService.logout().subscribe(() => {
          const client = this.authService.client.client;
          this.authService.userLogout();
          this.notificationService.clearAllDateForNotification();
          this.authService.setloginInfoSubject(false);
          this.commonService.clearService();
          this.commonBookingService.clearService();
          this.permissionsGuardService.clearPagePermissions();
          this.idleSubscription.unsubscribe();
          this.router.navigate([`${client}/login`]);
          this.sessionNotificationService.notify('Session Expired, Please login to continue');
        });
    });
      this.reset();
    });
  }

  closeDialog() {
    this.sessionNotificationService.clear();
  }

  setSectionVisibility(url) {
    const urlItems = url.split('?');
    const urlRedirect = urlItems[0];
    if (urlRedirect.match(/^\/\w+\/(login|forgot-password|login-new|resetPassword-new)$/)) {
      this.showSidebar = false;
      this.showHeader = false;
      return;
    }
    switch (urlRedirect) {
      case '/bookings/create': this.showHeader = true; this.showSidebar = false; this.headerTitle = 'Create Booking'; this.showNotification = false; break;
      case '/bookings/edit': this.showSidebar = false; this.showHeader = true; break;
      case '/bookings': this.showSidebar = true; this.showHeader = true; this.headerTitle = 'My Bookings'; this.showNotification = false; break;
      case '/bookings/bulk-create': this.showHeader = true; this.showSidebar = false; this.headerTitle = 'Bulk Booking'; this.showNotification = false; break;
      case '/requests-view':
      case '/bookings-view': this.showSidebar = true; this.showHeader = true; this.headerTitle = 'Booking View'; this.showNotification = false; break;
      case '/bookings-new/create': this.showSidebar = true; break;
      case '/billing-report': this.showSidebar = true; this.showHeader = true; this.headerTitle = 'Billing Reports'; this.showNotification = false; break;
      case '/invoicing': this.headerTitle = 'Invoicing & Payment'; this.showHeader = true; this.showSidebar = true; this.showNotification = false; break;
      case '/tracking': this.showHeader = true; this.showSidebar = true; this.headerTitle = 'Tracking'; this.showNotification = false; break;
      case '/bookings-filtered-view': this.showHeader = false; this.showNotification = true; break;
      case '/bookings-filtered-vendor-view': this.showHeader = false; this.showNotification = true; break;
      case '/profile': this.showSidebar = true; this.showHeader = true; this.headerTitle = 'Payments'; break;
      // case  '/tracking':
      case '/header-notifications': this.showHeader = false; this.showSidebar = true; break;
      case '/:client/login-new': this.showSidebar = false; this.showHeader = false; break;
      case '/:client/resetPassword-new': this.showSidebar = false; this.showHeader = false; break;
      case '/bookings-filtered-cab-view': this.showHeader = false; this.showNotification = true; break;
      case '/invoicing/edit': this.showSidebar = true; this.showHeader = true; this.headerTitle = 'Invoicing & Payment'; this.showNotification = false; break;
      case '/error': this.showSidebar = false; this.showHeader = true; this.showNotification = false; break;
      case '/auto-vendor-allocation': this.showSidebar = true; this.showHeader = true; this.showNotification = false; this.headerTitle = 'Auto Vendor Allocation'; break;
      case '/vehicle-allocation': this.showSidebar = true; this.showHeader = true; this.showNotification = false; this.headerTitle = 'Vehicle Availability'; break;
      default: this.showSidebar = false; this.showHeader = true; this.showNotification = false;
    }
  }

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      this.authService.init();
      this.authService.getServerTime({ buid: this.authService.user.buId }).
        subscribe((response) => {
          this.authService.serverTime = response;
        });
      const queryParams = {
        buid: this.authService.user.buId,
        client: this.authService.client.client,
        empGuid: this.authService.user.employeeGuid
      };
      this.checkForIdleness();
      this.notificationService.fetchNotificationConfig(queryParams).
        subscribe((response) => {
          if (response.showNotification && !this.router.url.includes('/reset-password')) {
            this.notificationService.setNotificationConfig(response);
            this.fetchNotificationInfo(response);
          }
        });
    }
    this.notificationService.logoutSubject$.subscribe(() => {
      this.idleSubscription.unsubscribe();
    });
    this.errorNotificationService
      .notification$
      .subscribe(message => {
        this.notification = message;
      });
    this.sessionNotificationService
    .notification$
    .subscribe(message => {
      this.sessionExpirationMsg = message;
    });
    this.authService.isLoginDone$.pipe((filter(Boolean))).
      subscribe((res) => {
        this.checkForIdleness();
        const queryParams = {
          buid: this.authService.user.buId,
          client: this.authService.client.client,
          empGuid: this.authService.user.employeeGuid
        };
        this.notificationService.fetchNotificationConfig(queryParams).
          subscribe((response) => {
            if (response.showNotification) {
              this.notificationService.setNotificationConfig(response);
              this.fetchNotificationInfo(response);
            }
          });
      });

    this.notify.closeNotificationObs.subscribe((res) => {
      if (res === 'createBooking') { this.audioCreateBooking.pause(); }
      if (res === 'vendorAcceptance') { this.audioVendorAcceptance.pause(); }
      if (res === 'cabAllocation') { this.audiocabAllocation.pause(); }
    });

    this.router.events.subscribe(event => {
      // Track page views when the NavigationEnd event occurs
      if (event instanceof NavigationEnd) {
        rg4js('trackEvent', {
          type: 'pageView',
          path: event.url
        });
      }

      // Track navigation errors when the NavigationError event occurs
      if (event instanceof NavigationError) {
        // Track navigation error
        rg4js('send', {
          error: event.error
        });
      }
    });


  }


  onDialogConfirm() {
    this.errorNotificationService.clear();
  }

  fetchNotificationInfo(config) {
    this.audioCreateBooking = new Audio('assets/sound.mp3');
    this.audioVendorAcceptance = new Audio('assets/sound.mp3');
    this.audiocabAllocation = new Audio('assets/sound.mp3');
    this.notificationService.logoutSubject$.subscribe(() => {
      this.timerSubs.unsubscribe();
    });

    const request = {
      cabNotificationTime: config.cabAssignment,
      buid: this.authService.user.buId,
      client: this.authService.client.client,
      vendorAcceptanceNotificationTime: config.vendorApproval,
      vendorAssignmentNotificationTime: config.vendorAllocation,
      vendorGuid: this.authService.user.role === 'VENDOR_MANAGER' ? this.authService.user.vendorGuid : null
    };
    this.timerObs = timer(0, 1000 * 60).
      pipe(switchMap(() => this.notificationService.fetchNotificationInfo(request)));
    this.timerSubs = this.timerObs.subscribe((res) => {
      this.notificationInfo = res;
      this.authService.getServerTime({ buid: this.authService.user.buId }).
        subscribe((response) => {
          this.authService.serverTime = response;
          let msg1;
          let msg2;
          let msg3;
          if (this.notificationInfo.vendorAssignmentList) {
            msg1 = this.notificationInfo.vendorAssignmentList.length === 1 ?
            'Vendor Assignment needed for' : 'Vendor Assignment needed for';
          }
          if (this.notificationInfo.vendorAcceptancePendingList) {
            msg2 = this.notificationInfo.vendorAcceptancePendingList.length === 1 ?
            'Vendor Acknowledgement needed for' : 'Vendor Acknowledgement needed for';
          }
          if (this.notificationInfo.cabAssignmentList) {
            msg3 = this.notificationInfo.cabAssignmentList.length === 1 ?
            'Cab Allocation needed for' : 'Cab Allocation needed for';
          }
          const bookingCreationMsg = this.notificationInfo.vendorAssignmentList ?
          `${msg1} ${this.notificationInfo.vendorAssignmentList.length} booking(s)` : '';
          const vendorAcceptanceMsg = this.notificationInfo.vendorAcceptancePendingList ?
          `${msg2} ${this.notificationInfo.vendorAcceptancePendingList.length} booking(s)` :  null;
          const cabAllocationMsg = this.notificationInfo.cabAssignmentList ?
          `${msg3} ${this.notificationInfo.cabAssignmentList.length} booking(s)` : null;
          const bookingInfoFromStorage = JSON.parse(localStorage.getItem('lastUpdatedTimebookingCreation'));
          const vendorInfoFromStorage = JSON.parse(localStorage.getItem('lastUpdatedTimeVendorAcceptance'));
          const cabInfoFromStorage = JSON.parse(localStorage.getItem('lastUpdatedTimeCabAllocation'));

          // vendor assignment logic

          if (config.showVendorAssignmentNotification) {
            this.notificationService.setBookingCreationInfo(this.notificationInfo.vendorAssignmentList);

            const updateBookingCreationInfo = {
              updatedTime: this.utilService.convertMomentToDateTimeStringWithoutSec(this.utilService.getMoment()),
              count: this.notificationInfo.vendorAssignmentList.length
            };
            if (bookingInfoFromStorage) {
              if (this.audioCreateBooking && (Math.floor(-1 * this.utilService.findTimeDiffInMinutes(bookingInfoFromStorage.updatedTime))) >= config.alertInterval
                && this.notificationInfo.vendorAssignmentList.length > 0
              ) {
                this.notificationService.setBookingInfoStorage(updateBookingCreationInfo);
                this.notificationService.setBookingCreationInfo(this.notificationInfo.vendorAssignmentList);
                this.notify.error('', bookingCreationMsg, 10000, 'createBooking');
                this.audioCreateBooking.play();
              } else if (this.notificationInfo.lastBookingCreationDatetime && bookingInfoFromStorage.updatedTime
                !== this.utilService.convertMomentToDateTimeStringWithoutSec(this.notificationInfo.lastBookingCreationDatetime)
                && (this.notificationInfo.vendorAssignmentList.length > bookingInfoFromStorage.count)) {
                this.notificationService.setBookingInfoStorage(updateBookingCreationInfo);
                this.notificationService.setBookingCreationInfo(this.notificationInfo.vendorAssignmentList);
                this.notify.error('', bookingCreationMsg, 10000, 'createBooking');
                this.audioCreateBooking.play();
              } else if (this.notificationInfo.vendorAssignmentList.length ===  0) {
                const info = {
                  updatedTime: bookingInfoFromStorage.updatedTime,
                  count: 0
                };
                this.notificationService.setBookingCreationInfo(this.notificationInfo.vendorAssignmentList);
                this.notificationService.setBookingInfoStorage(info);
              }
            } else {
              if (this.notificationInfo.lastBookingCreationDatetime && (Math.floor(-1 * this.utilService.findTimeDiffInMinutes(
                this.utilService.convertMomentToDateTimeStringWithoutSec(this.notificationInfo.lastBookingCreationDatetime))))
                >= config.alertInterval
                && this.notificationInfo.vendorAssignmentList.length > 0
              ) {
                this.notificationService.setBookingInfoStorage(updateBookingCreationInfo);
                this.notificationService.setBookingCreationInfo(this.notificationInfo.vendorAssignmentList);
                this.notify.error('', bookingCreationMsg, 10000, 'createBooking');
                this.audioCreateBooking.play();
              }
            }
          }

          // vendor acceptance logic

          if (config.showVendorAcceptanceNotification) {
            this.notificationService.setVendorAssignmentInfo(this.notificationInfo.vendorAcceptancePendingList);
            const updateVendorAcceptanceInfo = {
              updatedTime: this.utilService.convertMomentToDateTimeStringWithoutSec(this.utilService.getMoment()),
              count: this.notificationInfo.vendorAcceptancePendingList.length
            };
            if (vendorInfoFromStorage) {
              if ((Math.floor(-1 * this.utilService.findTimeDiffInMinutes(vendorInfoFromStorage.updatedTime))) >= config.alertInterval
                && this.notificationInfo.vendorAcceptancePendingList.length > 0
              ) {
                this.notificationService.setVendorInfoStorage(updateVendorAcceptanceInfo);
                this.notificationService.setVendorAssignmentInfo(this.notificationInfo.vendorAcceptancePendingList);
                this.notify.info('', vendorAcceptanceMsg, 10000, 'vendorAcceptance');
                this.audioVendorAcceptance.play();
              } else if (vendorInfoFromStorage.updatedTime
                !== this.utilService.convertMomentToDateTimeStringWithoutSec(this.notificationInfo.lastVendorAssignmentDatetime)
                && (this.notificationInfo.vendorAcceptancePendingList.length > vendorInfoFromStorage.count)) {
                this.notificationService.setVendorInfoStorage(updateVendorAcceptanceInfo);
                this.notificationService.setVendorAssignmentInfo(this.notificationInfo.vendorAcceptancePendingList);
                this.notify.info('', vendorAcceptanceMsg, 10000, 'vendorAcceptance');
                this.audioVendorAcceptance.play();
              } else if (this.notificationInfo.vendorAcceptancePendingList.length ===  0) {
                const info = {
                  updatedTime: vendorInfoFromStorage.updatedTime,
                  count: 0
                };
                this.notificationService.setVendorInfoStorage(info);
                this.notificationService.setVendorAssignmentInfo(this.notificationInfo.vendorAcceptancePendingList);
              }

            } else {
              if (this.notificationInfo.lastVendorAssignmentDatetime && (Math.floor(-1 * this.utilService.findTimeDiffInMinutes(
                this.utilService.convertMomentToDateTimeStringWithoutSec(this.notificationInfo.lastVendorAssignmentDatetime))))
                >= config.alertInterval
                && this.notificationInfo.vendorAcceptancePendingList.length > 0
              ) {
                this.notificationService.setVendorAssignmentInfo(this.notificationInfo.vendorAcceptancePendingList);
                this.notificationService.setVendorInfoStorage(updateVendorAcceptanceInfo);
                this.notify.info('', vendorAcceptanceMsg, 10000, 'vendorAcceptance');
                this.audioVendorAcceptance.play();
              }
            }
          }

          // cab allocation logic

          if (config.showCabAllocationNotification) {
            this.notificationService.setCabAssignmentInfo(this.notificationInfo.cabAssignmentList);
            const updatedCabAllocInfo = {
              updatedTime: this.utilService.convertMomentToDateTimeStringWithoutSec(this.utilService.getMoment()),
              count: this.notificationInfo.cabAssignmentList.length
            };
            if (cabInfoFromStorage) {
              if ((Math.floor(-1 * this.utilService.findTimeDiffInMinutes(cabInfoFromStorage.updatedTime))) >= config.alertInterval
                && this.notificationInfo.cabAssignmentList.length > 0
              ) {
                this.notificationService.setCabAllocationInfoStorage(updatedCabAllocInfo);
                this.notificationService.setCabAssignmentInfo(this.notificationInfo.cabAssignmentList);
                this.notify.warning('', cabAllocationMsg, 10000, 'cabAllocation');
                this.audiocabAllocation.play();

              } else if (this.notificationInfo.cabAssignmentList.length > cabInfoFromStorage.count) {
                this.notificationService.setCabAllocationInfoStorage(updatedCabAllocInfo);
                this.notificationService.setCabAssignmentInfo(this.notificationInfo.cabAssignmentList);
                this.notify.warning('', cabAllocationMsg, 10000, 'cabAllocation');
                this.audiocabAllocation.play();

              } else if (this.notificationInfo.cabAssignmentList.length ===  0) {
                const cabInfo = {
                  updatedTime: cabInfoFromStorage.updatedTime,
                  count: 0
                };

                this.notificationService.setCabAllocationInfoStorage(cabInfo);
                this.notificationService.setCabAssignmentInfo(this.notificationInfo.cabAssignmentList);
              }
            } else {
              if (this.notificationInfo.cabAssignmentList.length > 0) {
                this.notificationService.setCabAllocationInfoStorage(updatedCabAllocInfo);
                this.notificationService.setCabAssignmentInfo(this.notificationInfo.cabAssignmentList);
                this.notify.warning('', cabAllocationMsg, 10000, 'cabAllocation');
                this.audiocabAllocation.play();
              }
            }
          }
        });
    });
  }


  registerIcon(imgURL) {
    this.matIconRegistry.addSvgIcon(
      `delete`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/delete.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `search`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/search.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `close-grey`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/close-grey.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `cancel`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/cancel.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `add`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/add.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `minus-circle`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/minus-circle.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `plus-circle`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/plus-circle.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `arrow-up`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/arrow-up.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `clock`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/clock.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `error`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/error.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `cancel_24`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/cancel_24.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `back`,
      this.domSanitizer.bypassSecurityTrustResourceUrl( imgURL + "/images/back.svg")
    );
  }


}
